const ONE_DAY_MILLIS = 24 * 60 * 60 * 1000

export function determineCurrentTaskTimeSpan(endTimeMillis?: number) {
  if (!endTimeMillis) {
    return {
      start: 0,
      end: 2147483648000,
    }
  }
  return {
    start: endTimeMillis - ONE_DAY_MILLIS,
    end: endTimeMillis,
  }
}

export function isWithinCurrentTaskTimeSpan(datetimeMillis: number, season?: { start: number; end: number }) {
  if (!season) {
    return false
  }
  return season.start <= datetimeMillis && datetimeMillis <= season.end
}
